import React, { useState } from 'react'

import { makeStyles } from '@material-ui/core/styles';
import { Accordion, AccordionDetails, AccordionSummary, Typography } from '@material-ui/core'
import ExpandMoreIcon from '@material-ui/icons/ExpandMore'
import generateId from '../../utils/generateId';


const useStyles = makeStyles((theme) => ({
  accordionHeading: {
    fontSize: '18px',
    fontWeight: 500,
    color: '#222F3E',
    width: '100%',
  },
  accordionDetails: {
    display: 'flex',
    flexWrap: 'wrap',
  },
  accordionSummary: {
    margin: 0,
    justifyContent: 'space-between',
    '& .MuiAccordionSummary-content': {
      flexGrow: 0,
      overflow: 'hidden',
    },
  },
  sortableSummary: {
    paddingLeft: '50px'
  },
  grayTheme: {
    background: theme.palette.neutral.light3,
    border: '1px solid ' + theme.palette.neutral.med,
    '& .filename': {
      background: '#fff',
    }
  }
}));


export const Collapsible = ({children,headerTag='h4',title,defaultExpanded = false,grayTheme,sortableChild}) => {
  const [id] = useState(generateId('accordion-'));
  const classes = useStyles();

  return (
    <div>

      <Accordion defaultExpanded={defaultExpanded} elevation={grayTheme ? 0 : 1} className={grayTheme ? classes.grayTheme : ''}>
        
        <AccordionSummary
          expandIcon={<ExpandMoreIcon />}
          aria-controls="panel1a-content"
          id={id}
          className={`${classes.accordionSummary} ${sortableChild ? classes.sortableSummary : ''}`}
        >

          <Typography className={classes.accordionHeading} component={headerTag} variant="h6" noWrap={true}>{title}</Typography>

        </AccordionSummary>

        <AccordionDetails className={classes.accordionDetails}>
          {children}
        </AccordionDetails>

      </Accordion>
      
    </div>
  )
}